<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Envanter Ekranı</v-toolbar-title>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="inventoryItems"
      :loading="loading"
      :rows-per-page-items="[50, 100, 500, { text: 'Tümü', value: -1 }]"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="px-2">{{ props.item.inventoryTypeName }}</td>
        <td class="px-2">
          {{ props.item.productName }}
          <span v-if="props.item.kulp" class="caption grey--text"> · {{ props.item.kulp }}</span>
          <span v-if="props.item.dateType" class="caption grey--text"> · {{ props.item.dateType }}</span>
        </td>
        <td class="px-2">{{ props.item.weight }}</td>
        <td class="px-2">{{ props.item.purityLabel }}</td>
        <td class="px-2">{{ props.item.size || '-' }}</td>
        <td class="px-2">{{ props.item.hasPerUnit.toFixed(4) }}</td>
        <td class="px-2">{{ props.item.quantity }}</td>
        <td class="px-2">{{ props.item.totalHas.toFixed(4) }}</td>
        <td class="px-2">
          <v-btn
            v-if="props.item.inventoryType === 0"
            small
            flat
            color="primary"
            @click="goToJewelryList(props.item)"
          >Liste</v-btn>
          <v-btn
            v-else
            small
            flat
            color="teal"
            @click="printBarcode(props.item)"
          >
            <v-icon small left>print</v-icon>
            Yazdır
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <!-- Alt Butonlar -->
    <v-layout wrap justify-space-between class="mt-3 px-2">
      <v-flex xs12 md8>
        <v-btn color="amber darken-2" dark @click="openZiynetDialog" class="mb-2">
          <v-icon left>monetization_on</v-icon>
          Ziynet Ekle
        </v-btn>
        <v-btn color="blue-grey darken-1" dark @click="kulceDialog = true" class="mb-2">
          <v-icon left>view_in_ar</v-icon>
          Külçe Ekle
        </v-btn>
        <v-btn color="teal darken-1" dark @click="openTakiDialog" class="mb-2">
          <v-icon left>diamond</v-icon>
          Takı Ekle
        </v-btn>
        <v-btn color="brown darken-1" dark @click="openDigerDialog" class="mb-2">
          <v-icon left>category</v-icon>
          Diğer Ekle
        </v-btn>
      </v-flex>
      <v-flex xs12 md4 class="text-xs-right">
        <v-chip color="primary" text-color="white" large>
          <strong>Toplam Has: {{ totalHas.toFixed(4) }} gr</strong>
        </v-chip>
      </v-flex>
    </v-layout>

    <!-- ========== KÜLÇE EKLE DIALOG ========== -->
    <v-dialog v-model="kulceDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline blue-grey darken-1 white--text">
          <v-icon left color="white">view_in_ar</v-icon>
          Külçe Ekranı
        </v-card-title>
        <v-card-text class="pa-4">
          <v-combobox
            v-model="kulceForm.selectedProduct"
            :items="kulceProducts"
            item-text="label"
            item-value="weight"
            label="Ürün"
            return-object
          ></v-combobox>
          <v-text-field
            :value="kulceForm.selectedProduct ? kulceForm.selectedProduct.weight + ' gr' : ''"
            label="Ağırlık"
            readonly
          ></v-text-field>
          <v-combobox
            v-model="kulceForm.selectedPurity"
            :items="kulcePurities"
            item-text="label"
            item-value="value"
            label="Ayar"
            return-object
          ></v-combobox>
          <v-text-field
            :value="kulceHas"
            label="Has"
            readonly
            suffix="gr"
          ></v-text-field>
          <v-text-field
            v-model.number="kulceForm.quantity"
            label="Adet"
            type="number"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="kulceDialog = false">İptal</v-btn>
          <v-btn color="primary" dark :loading="kulceSaving" @click="saveKulce">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== ZİYNET EKLE DIALOG ========== -->
    <v-dialog v-model="ziynetDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline amber darken-2 white--text">
          <v-icon left color="white">monetization_on</v-icon>
          Ziynet Ekranı
        </v-card-title>
        <v-card-text class="pa-4">
          <v-combobox
            v-model="ziynetForm.selectedProduct"
            :items="ziynetProducts"
            item-text="label"
            item-value="name"
            label="Ürün"
            return-object
          ></v-combobox>
          <v-text-field
            :value="ziynetForm.selectedProduct ? ziynetForm.selectedProduct.weight + ' gr' : ''"
            label="Ağırlık"
            readonly
          ></v-text-field>
          <v-text-field
            :value="ziynetHas"
            label="Has"
            readonly
            suffix="gr"
          ></v-text-field>

          <!-- Kulp / Tarih varyantı -->
          <v-layout>
            <v-flex xs6 class="pr-2">
              <v-select
                v-model="ziynetForm.kulp"
                :items="['Kulplu', 'Kulpsuz']"
                label="Kulp"
              ></v-select>
            </v-flex>
            <v-flex xs6 class="pl-2">
              <v-select
                v-model="ziynetForm.dateType"
                :items="['Yeni', 'Eski']"
                label="Tarih"
              ></v-select>
            </v-flex>
          </v-layout>

          <!-- Tartı ile adet hesaplama -->
          <v-layout align-center class="mb-2">
            <v-flex>
              <v-text-field
                :value="ziynetWeighedTotal != null ? ziynetWeighedTotal + ' gr' : 'Tartılmadı'"
                label="Tartılan Toplam"
                readonly
                hide-details
              ></v-text-field>
            </v-flex>
            <v-btn
              color="teal"
              dark
              class="ml-3"
              :loading="ziynetScaleLoading"
              :disabled="!ziynetForm.selectedProduct"
              @click="readScaleForZiynet"
            >
              <v-icon left>fitness_center</v-icon>
              Tart
            </v-btn>
          </v-layout>

          <v-text-field
            v-model.number="ziynetForm.quantity"
            label="Adet"
            type="number"
            hint="Tart ile otomatik gelir; gerekirse düzenleyebilirsiniz."
            persistent-hint
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="ziynetDialog = false">İptal</v-btn>
          <v-btn color="primary" dark :loading="ziynetSaving" @click="saveZiynet">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== DİĞER EKLE DIALOG ========== -->
    <v-dialog v-model="digerDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline brown darken-1 white--text">
          <v-icon left color="white">category</v-icon>
          Diğer Kalem Ekle
        </v-card-title>
        <v-card-text class="pa-4">
          <v-select
            v-model="digerForm.selectedItem"
            :items="activeOtherItems"
            item-text="name"
            item-value="name"
            label="Kalem (Diğer Zimmet Kalemleri)"
            no-data-text="Önce 'Diğer Zimmet Kalemleri' ekranında tanımlayın"
            return-object
          ></v-select>
          <v-text-field
            v-model.number="digerForm.quantity"
            label="Adet"
            type="number"
          ></v-text-field>
          <div class="caption grey--text">
            Listede yoksa: Envanter Yönetimi → Diğer Zimmet Kalemleri'nden ekleyin.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="digerDialog = false">İptal</v-btn>
          <v-btn color="primary" dark :loading="digerSaving" @click="saveDiger">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== TAKI EKLE DIALOG ========== -->
    <v-dialog v-model="takiDialog" max-width="900" persistent>
      <v-card>
        <v-card-title class="headline teal darken-1 white--text">
          <v-icon left color="white">diamond</v-icon>
          Takı Ekleme Ekranı
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeTakiDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-layout wrap>
            <!-- Sol: Form -->
            <v-flex xs12 md6 class="pr-3">
              <v-combobox
                v-model="takiForm.selectedProduct"
                :items="takiProducts"
                label="Ürün"
              ></v-combobox>
              <v-combobox
                v-model="takiForm.selectedSize"
                :items="takiSizes"
                label="Ölçü"
              ></v-combobox>
              <v-combobox
                v-model="takiForm.selectedPurity"
                :items="takiPurities"
                item-text="label"
                item-value="value"
                label="Ayar"
                return-object
              ></v-combobox>
              <v-layout align-center>
                <v-flex grow>
                  <v-text-field
                    :value="takiForm.weight != null ? takiForm.weight + ' gr' : 'Tartım bekleniyor...'"
                    label="Ağırlık"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex shrink class="ml-2">
                  <v-btn small color="teal" dark @click="readScaleForTaki" :loading="scaleLoading">
                    <v-icon small left>fitness_center</v-icon>
                    Tartımı Oku
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-text-field
                :value="takiHas"
                label="Has"
                readonly
                suffix="gr"
              ></v-text-field>
              <div v-if="takiRoundingDifferenceText" class="subtitle-1 py-2" style="color: #00695c;">
                {{ takiRoundingDifferenceText }}
              </div>
              <v-text-field
                :value="takiForm.serialNumber || 'Kayıt sonrası oluşur'"
                label="Seri No"
                readonly
              ></v-text-field>
              <div v-if="takiForm.serialNumber" class="mt-2 pa-2 text-center taki-barcode-box">
                <div class="caption grey--text">Barkod</div>
                <barcode
                  class="taki-barcode-img"
                  :value="takiForm.serialNumber"
                  format="CODE128"
                  width="1.5"
                  :displayValue="false"
                />
                <div class="title font-weight-bold mt-1">{{ takiForm.serialNumber }}</div>
              </div>
            </v-flex>
            <!-- Sağ: Webcam -->
            <v-flex xs12 md6 class="pl-3">
              <div class="caption grey--text mb-1">Ürün Fotoğrafı</div>
              <webcam-capture
                v-if="takiDialog"
                ref="webcam"
                @captured="onPhotoCaptured"
              ></webcam-capture>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn v-if="takiForm.serialNumber" color="primary" @click="printTakiCertificate">
            <v-icon left>print</v-icon>
            Yazdır
          </v-btn>
          <v-btn text color="grey" @click="closeTakiDialog">İptal</v-btn>
          <v-btn color="teal" dark :loading="takiSaving" :disabled="!takiForm.photoBase64 || takiForm.photoBase64.trim() === ''" @click="saveTaki">
            <v-icon left>save</v-icon>
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import WebcamCapture from "@/components/WebcamCapture.vue";
import VueBarcode from "vue-barcode";
import { readScaleWeight } from "@/utils/scaleSerial";
import apiSettings from "@/api/appSettings";

export default {
  components: { WebcamCapture, barcode: VueBarcode },
  data: () => ({
    loading: false,
    inventoryItems: [],
    totalHas: 0,
    headers: [
      { text: "Tip", value: "inventoryTypeName" },
      { text: "Ürün", value: "productName" },
      { text: "Ağırlık", value: "weight" },
      { text: "Ayar", value: "purityLabel" },
      { text: "Ölçü", value: "size" },
      { text: "Has", value: "hasPerUnit" },
      { text: "Adet", value: "quantity" },
      { text: "Toplam Has", value: "totalHas" },
      { text: "", value: "actions", sortable: false },
    ],

    // Külçe
    kulceDialog: false,
    kulceSaving: false,
    kulceForm: {
      selectedProduct: null,
      selectedPurity: null,
      quantity: 1,
    },
    // Açılır liste tanımları envanter tanımları API'sinden yüklenir (loadDefinitions).
    kulceProducts: [],
    kulcePurities: [],

    // Ziynet
    ziynetDialog: false,
    ziynetSaving: false,
    ziynetScaleLoading: false,
    ziynetWeighedTotal: null,
    ziynetForm: {
      selectedProduct: null,
      kulp: "Kulpsuz",
      dateType: "Yeni",
      quantity: 1,
    },
    ziynetProducts: [],

    // Takı
    takiDialog: false,
    takiSaving: false,
    scaleLoading: false,
    takiForm: {
      selectedProduct: null,
      selectedSize: null,
      selectedPurity: null,
      weight: null,
      serialNumber: null,
      photoBase64: null,
    },
    takiProducts: [],
    takiSizes: [],
    takiPurities: [],
    hasFiyat: null,

    // Diğer
    digerDialog: false,
    digerSaving: false,
    digerForm: {
      selectedItem: null,
      quantity: 1,
    },
    otherItems: [],
  }),

  computed: {
    activeOtherItems() {
      return (this.otherItems || []).filter((o) => o.isActive);
    },
    kulceHas() {
      if (!this.kulceForm.selectedProduct || !this.kulceForm.selectedPurity) return "";
      const w = this.kulceForm.selectedProduct.weight;
      const p = this.kulceForm.selectedPurity.value;
      return (w * (p / 1000)).toFixed(4);
    },
    ziynetHas() {
      if (!this.ziynetForm.selectedProduct) return "";
      const w = this.ziynetForm.selectedProduct.weight;
      const p = this.ziynetForm.selectedProduct.purity;
      return (w * (p / 1000)).toFixed(4);
    },
    takiHas() {
      if (!this.takiForm.weight || !this.takiForm.selectedPurity) return "";
      return (this.takiForm.weight * (this.takiForm.selectedPurity.value / 1000)).toFixed(4);
    },
    takiRoundingDifferenceText() {
      if (!this.takiForm.weight || !this.takiForm.selectedPurity || !this.hasFiyat || this.hasFiyat <= 0) return "";
      const w = parseFloat(this.takiForm.weight);
      const rounded = Math.round(w);
      const diffGr = rounded - w;
      if (Math.abs(diffGr) < 0.0001) return "";
      const p = this.takiForm.selectedPurity.value;
      const diffHas = diffGr * (p / 1000);
      const diffTl = (diffHas * this.hasFiyat).toFixed(2);
      return `Yuvarlama: ${w} gr → ${rounded} gr, fark ${diffGr.toFixed(2)} gr (has: ${diffHas.toFixed(4)}). Fark: ${diffTl} TL`;
    },
  },

  methods: {
    // Envanter ekleme açılır listelerini (Takı/Külçe/Ziynet) tanım API'sinden yükler.
    async loadDefinitions() {
      try {
        const defs = (await this.$store.dispatch("inventory/getDefinitions")) || [];
        // Aynı etiket hem tenant'a özel hem ortak (tenant 0) olabilir → label bazında tekilleştir.
        const seenLabel = {};
        const pick = (type, cat) =>
          defs
            .filter((d) => d.inventoryType === type && d.category === cat && d.isActive)
            .filter((d) => {
              const k = `${type}|${cat}|${(d.label || "").trim().toLocaleLowerCase("tr")}`;
              if (seenLabel[k]) return false;
              seenLabel[k] = true;
              return true;
            });
        // type: 0=Takı,1=Ziynet,2=Külçe ; cat: 0=Ürün,1=Ölçü,2=Ayar
        this.takiProducts = pick(0, 0).map((d) => d.label);
        this.takiSizes = pick(0, 1).map((d) => d.label);
        this.takiPurities = pick(0, 2).map((d) => ({ label: d.label, value: d.value }));
        this.kulceProducts = pick(2, 0).map((d) => ({ label: d.label, weight: d.value }));
        this.kulcePurities = pick(2, 2).map((d) => ({ label: d.label, value: d.value }));
        this.ziynetProducts = pick(1, 0).map((d) => ({
          label: d.label,
          name: d.label,
          weight: d.value,
          purity: d.purity,
          purityLabel: d.purityLabel,
        }));
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Envanter tanımları yüklenemedi:", e);
      }
    },
    async loadData() {
      this.loading = true;
      try {
        const [itemsRes, hasRes] = await Promise.all([
          this.$store.dispatch("inventory/getInventoryItems"),
          this.$store.dispatch("inventory/getTotalHas"),
        ]);
        this.inventoryItems = itemsRes;
        this.totalHas = hasRes;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Envanter yüklenemedi:", e);
      } finally {
        this.loading = false;
      }
    },

    goToJewelryList(item) {
      const query = {};
      if (item && item.productName) query.productName = item.productName;
      if (item && item.size) query.size = item.size;
      if (item && item.weight != null) query.weightRounded = item.weight; // 0,5'lik kova değeri (ör. 4.5)
      if (item && item.purity != null) query.purity = item.purity;
      if (item && item.purityLabel) query.purityLabel = item.purityLabel;
      this.$router.push({ path: "/admin/inventory/jewelry", query });
    },

    // Ziynet/Külçe tip barkodunu yazdır (barkod + ürün adı etiketi)
    printBarcode(item) {
      if (!item || !item.barcode) {
        this.$store.state.dialog = true;
        this.$store.state.message =
          "Bu ürün için barkod bulunamadı. Veritabanı güncellemesi (order_reading_migration.sql) çalıştırılmalı.";
        return;
      }
      const url =
        "/print/inventory-barcode?code=" + encodeURIComponent(item.barcode) +
        "&name=" + encodeURIComponent(item.productName || "");
      window.open(url, "_blank", "noopener,noreferrer");
    },

    // --- Külçe ---
    async saveKulce() {
      if (!this.kulceForm.selectedProduct || !this.kulceForm.selectedPurity
          || !Number.isFinite(this.kulceForm.quantity)) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Ürün ve ayar seçin; geçerli bir adet girin (negatif olabilir).";
        return;
      }
      this.kulceSaving = true;
      try {
        await this.$store.dispatch("inventory/addKulce", {
          productName: this.kulceForm.selectedProduct.label,
          weight: this.kulceForm.selectedProduct.weight,
          purity: this.kulceForm.selectedPurity.value,
          purityLabel: this.kulceForm.selectedPurity.label,
          quantity: this.kulceForm.quantity,
        });
        this.kulceDialog = false;
        this.kulceForm = { selectedProduct: null, selectedPurity: null, quantity: 1 };
        this.$store.state.dialog = true;
        this.$store.state.message = "Külçe başarıyla eklendi.";
        await this.loadData();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.kulceSaving = false;
      }
    },

    // --- Ziynet ---
    openZiynetDialog() {
      this.ziynetForm = { selectedProduct: null, kulp: "Kulpsuz", dateType: "Yeni", quantity: 1 };
      this.ziynetWeighedTotal = null;
      this.ziynetDialog = true;
    },
    // Terazi okur ve seçili ziynetin birim ağırlığına bölerek adedi otomatik hesaplar.
    // Sadece tartar/hesaplar — stoğa EKLEMEZ (ekleme yalnızca "Kaydet" ile). Adet düzenlenebilir.
    async readScaleForZiynet() {
      if (!this.ziynetForm.selectedProduct) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Önce ürün seçin.";
        return;
      }
      this.ziynetScaleLoading = true;
      try {
        const data = await readScaleWeight({ requestPortIfNeeded: true });
        if (data.success) {
          this.ziynetWeighedTotal = data.weight;
          const unit = this.ziynetForm.selectedProduct.weight;
          if (unit > 0) {
            this.ziynetForm.quantity = Math.max(0, Math.round(data.weight / unit));
          }
        } else {
          this.$store.state.dialog = true;
          this.$store.state.message = data.message || "Teraziden veri okunamadı.";
        }
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = (e && e.message) || "Terazi bağlantı hatası. Chrome/Edge ve HTTPS (veya localhost) gerekir.";
      } finally {
        this.ziynetScaleLoading = false;
      }
    },
    async saveZiynet() {
      if (!this.ziynetForm.selectedProduct
          || !Number.isFinite(this.ziynetForm.quantity)) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Ürün seçin; geçerli bir adet girin (negatif olabilir).";
        return;
      }
      this.ziynetSaving = true;
      try {
        await this.$store.dispatch("inventory/addZiynet", {
          productName: this.ziynetForm.selectedProduct.name,
          kulp: this.ziynetForm.kulp,
          dateType: this.ziynetForm.dateType,
          quantity: this.ziynetForm.quantity,
        });
        this.ziynetDialog = false;
        this.ziynetForm = { selectedProduct: null, kulp: "Kulpsuz", dateType: "Yeni", quantity: 1 };
        this.ziynetWeighedTotal = null;
        this.$store.state.dialog = true;
        this.$store.state.message = "Ziynet başarıyla eklendi.";
        await this.loadData();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.ziynetSaving = false;
      }
    },

    // --- Diğer ---
    async openDigerDialog() {
      this.digerForm = { selectedItem: null, quantity: 1 };
      try {
        this.otherItems = (await this.$store.dispatch("inventory/getOtherItems")) || [];
      } catch (e) {
        this.otherItems = [];
      }
      this.digerDialog = true;
    },
    async saveDiger() {
      const name = this.digerForm.selectedItem
        ? (this.digerForm.selectedItem.name || this.digerForm.selectedItem)
        : null;
      if (!name || !Number.isFinite(this.digerForm.quantity)) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Kalem seçin; geçerli bir adet girin (negatif olabilir).";
        return;
      }
      this.digerSaving = true;
      try {
        await this.$store.dispatch("inventory/addDiger", {
          productName: name,
          quantity: this.digerForm.quantity,
        });
        this.digerDialog = false;
        this.digerForm = { selectedItem: null, quantity: 1 };
        this.$store.state.dialog = true;
        this.$store.state.message = "Diğer kalem eklendi.";
        await this.loadData();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.digerSaving = false;
      }
    },

    // --- Takı ---
    openTakiDialog() {
      this.takiForm = {
        selectedProduct: null,
        selectedSize: null,
        selectedPurity: null,
        weight: null,
        serialNumber: null,
        photoBase64: null,
      };
      this.takiDialog = true;
    },
    closeTakiDialog() {
      this.takiDialog = false;
    },
    async readScaleForTaki() {
      this.scaleLoading = true;
      try {
        const data = await readScaleWeight({ requestPortIfNeeded: true });
        if (data.success) {
          this.takiForm.weight = data.weight;
        } else {
          this.takiForm.weight = 0;
          this.$store.state.dialog = true;
          this.$store.state.message = data.message || "Teraziden veri okunamadı.";
        }
      } catch (e) {
        this.takiForm.weight = 0;
        this.$store.state.dialog = true;
        this.$store.state.message = (e && e.message) || "Terazi bağlantı hatası.";
      } finally {
        this.scaleLoading = false;
      }
    },
    onPhotoCaptured(base64) {
      this.takiForm.photoBase64 = base64;
    },
    printTakiCertificate() {
      const photoSrc = this.takiForm.photoBase64
        ? "data:image/jpeg;base64," + this.takiForm.photoBase64
        : null;
      const certData = {
        productName: this.takiForm.selectedProduct,
        size: this.takiForm.selectedSize,
        weight: this.takiForm.weight,
        purityLabel: this.takiForm.selectedPurity ? this.takiForm.selectedPurity.label : null,
        serialNumber: this.takiForm.serialNumber,
        photoSrc,
      };
      localStorage.setItem("jewelryCertificateData", JSON.stringify(certData));
      window.open("/print/jewelry-certificate?template=classic", "_blank", "noopener,noreferrer");
    },
    async saveTaki() {
      if (!this.takiForm.selectedProduct || !this.takiForm.selectedSize ||
          !this.takiForm.selectedPurity || this.takiForm.weight == null) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Lütfen tüm alanları doldurun ve tartımı okuyun.";
        return;
      }
      if (!this.takiForm.photoBase64 || this.takiForm.photoBase64.trim() === "") {
        this.$store.state.dialog = true;
        this.$store.state.message = "Lütfen ürün fotoğrafı çekin.";
        return;
      }
      this.takiSaving = true;
      try {
        const result = await this.$store.dispatch("inventory/addTaki", {
          productName: this.takiForm.selectedProduct,
          size: this.takiForm.selectedSize,
          purity: this.takiForm.selectedPurity.value,
          purityLabel: this.takiForm.selectedPurity.label,
          weight: this.takiForm.weight,
          photoBase64: this.takiForm.photoBase64 || null,
        });
        this.takiForm.serialNumber = result.serialNumber;
        this.$store.state.dialog = true;
        this.$store.state.message = `Takı eklendi. Seri No: ${result.serialNumber}`;
        await this.loadData();
        // Dialog açık bırak ki seri no ve barkod görünsün
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.takiSaving = false;
      }
    },
  },

  async mounted() {
    try {
      const configRes = await apiSettings.getConfig();
      if (configRes.data && configRes.data.hasFiyat != null) {
        this.hasFiyat = parseFloat(configRes.data.hasFiyat) || null;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("Config alınamadı:", e);
    }
    await this.loadDefinitions();
    await this.loadData();
  },
};
</script>

<style scoped>
.taki-barcode-box {
  border: 1px solid #ccc;
  border-radius: 4px;
}
.taki-barcode-img {
  display: block;
  margin: 4px auto;
}
</style>
